"use client";

import styled from "styled-components";
import { textStyle } from "../../dimensions/typography";
var Mauna = styled.span.withConfig({
  displayName: "TextStyle__Mauna",
  componentId: "sc-1vd3o1f-0"
})(["", ""], textStyle.mauna);
var Everest = styled.span.withConfig({
  displayName: "TextStyle__Everest",
  componentId: "sc-1vd3o1f-1"
})(["", ""], textStyle.everest);
var Kilimanjaro = styled.span.withConfig({
  displayName: "TextStyle__Kilimanjaro",
  componentId: "sc-1vd3o1f-2"
})(["", ""], textStyle.kilimanjaro);
var Matterhorn = styled.span.withConfig({
  displayName: "TextStyle__Matterhorn",
  componentId: "sc-1vd3o1f-3"
})(["", ""], textStyle.matterhorn);
var Vinson = styled.span.withConfig({
  displayName: "TextStyle__Vinson",
  componentId: "sc-1vd3o1f-4"
})(["", ""], textStyle.vinson);
var Blanc = styled.span.withConfig({
  displayName: "TextStyle__Blanc",
  componentId: "sc-1vd3o1f-5"
})(["", ""], textStyle.blanc);
var Fiji = styled.span.withConfig({
  displayName: "TextStyle__Fiji",
  componentId: "sc-1vd3o1f-6"
})(["", ""], textStyle.fiji);
var Rainier = styled.span.withConfig({
  displayName: "TextStyle__Rainier",
  componentId: "sc-1vd3o1f-7"
})(["", ""], textStyle.rainier);
var Boising = styled.span.withConfig({
  displayName: "TextStyle__Boising",
  componentId: "sc-1vd3o1f-8"
})(["", ""], textStyle.boising);
var Etna = styled.span.withConfig({
  displayName: "TextStyle__Etna",
  componentId: "sc-1vd3o1f-9"
})(["", ""], textStyle.etna);
var Nevis = styled.span.withConfig({
  displayName: "TextStyle__Nevis",
  componentId: "sc-1vd3o1f-10"
})(["", ""], textStyle.nevis);
var Snowdon = styled.span.withConfig({
  displayName: "TextStyle__Snowdon",
  componentId: "sc-1vd3o1f-11"
})(["", ""], textStyle.snowdon);
var TextStyle = {
  Mauna: Mauna,
  Everest: Everest,
  Kilimanjaro: Kilimanjaro,
  Matterhorn: Matterhorn,
  Vinson: Vinson,
  Blanc: Blanc,
  Fiji: Fiji,
  Rainier: Rainier,
  Boising: Boising,
  Etna: Etna,
  Nevis: Nevis,
  Snowdon: Snowdon
};
export default TextStyle;